module.exports = __webpack_public_path__ + "970ce7651ac970c0bc11bf29804ca04c.gif";